import Backbone from "backbone";
import { View } from "../database-reader/base-database-reader";
import { DB_PROVIDERS } from "../database-reader/configs/db-providers";

class OracleCDCReader extends View {
    setup() {
        this.model.get("connectionParams").set("type", DB_PROVIDERS.ORACLE.id);
        this.model.set("isCDC", true);
    }
}

export default {
    View: OracleCDCReader,
    vent: new Backbone.Model()
};
